import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: string): string {
    if (value) {
      return this.translocoService.translate(`userRoles.${value}`);
    }
    return value;
  }
}
